import styled, { css } from 'styled-components'

import { Box, BoxProps } from '../Box'
import { BriqTheme, ThemeWrapper } from '../theme'

const StyledText = styled(Box)<{ underline?: boolean; noWrap?: boolean }>`
  color: ${({ color, theme }) => {
      const themeColor = color as keyof BriqTheme['colors']
      return themeColor ? theme.colors[themeColor] : 'inherit'
    }}
    ${props =>
      props.underline &&
      css`
        text-decoration: underline;
      `}
    ${props =>
      props.noWrap &&
      css`
        white-space: nowrap;
      `};
`

export type TextProps = {
  block?: boolean
  bold?: boolean
  underline?: boolean
  noWrap?: boolean
} & BoxProps

export const Text = ({ children, block, bold, ...rest }: TextProps) => {
  return (
    <ThemeWrapper>
      <StyledText block={block ? true : false} fontWeight={bold ? 'bold' : undefined} {...rest}>
        {children}
      </StyledText>
    </ThemeWrapper>
  )
}
